import Util from "../../../../services/util";
const util = Util.getInstance()

// 用户组列表
export const getList = (values?: any) => {
  return util.httpGet('/sinzetech-admin-user/user-groups', values)
    .then(res => res)
}